var _desc, _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "svg2",
    viewBox: "0 0 500 670",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Source: openclipart.org/detail/209545")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "M -43.757 536.119 C -24.129 537.033 -9.912 544.304 -0.935 557.642 C 8.055 568.798 9.869 580.295 4.473 592.57 C -0.935 602.611 -11.558 607.648 -27.727 607.648 C -42.98 606.516 -56.319 601.515 -68.006 592.57 C -78.613 583.696 -80.89 571.977 -74.57 557.642 C -67.553 543.137 -57.201 536.119 -43.757 536.119 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "matrix(36.415085, 0, 0, 38.179169, -92.622406, -237.186722)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(36.415085, 0, 0, 38.179169, -92.622406, -237.186722)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier",
    transform: "matrix(27.204321, -0.062985, 0, 19.752676, -71.413429, 272.982269)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0303 17.5303C9.73744 17.8232 9.26256 17.8232 8.96967 17.5303L3.96967 12.5303C3.67678 12.2374 3.67678 11.7626 3.96967 11.4697L8.96967 6.46967C9.26256 6.17678 9.73744 6.17678 10.0303 6.46967C10.3232 6.76256 10.3232 7.23744 10.0303 7.53033L5.56066 12L10.0303 16.4697C10.3232 16.7626 10.3232 17.2374 10.0303 17.5303Z",
    fill: "#005DF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31066 12.75H14.5C15.4534 12.75 16.8667 12.4702 18.0632 11.6086C19.298 10.7196 20.25 9.24444 20.25 7C20.25 6.58578 19.9142 6.25 19.5 6.25C19.0858 6.25 18.75 6.58578 18.75 7C18.75 8.75556 18.0353 9.7804 17.1868 10.3913C16.3 11.0298 15.2133 11.25 14.5 11.25L6.31066 11.25L5.56066 12L6.31066 12.75Z",
    fill: "#005DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80691 12.2871C3.77024 12.1987 3.75 12.1017 3.75 12C3.75 12.0977 3.76897 12.1954 3.80691 12.2871Z",
    fill: "#005DF2"
  })))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(27, 107, 217)",
      fontFamily: "Arial, sans-serif",
      fontSize: 150,
      fontWeight: 700,
      whiteSpace: "pre"
    },
    x: 183.486,
    y: 334.999,
    id: "object-0",
    transform: "matrix(2.455595, 0, 0, 2.572092, -408.822052, -518.114868)"
  }, "\u540F"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.48461cb7a1919bd8789eb7a1cd97949b.svg";
export { ForwardRef as ReactComponent };